exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "table[data-v-6fb947cc]{border-collapse:collapse}table[data-v-6fb947cc],td[data-v-6fb947cc],th[data-v-6fb947cc]{border:1px solid #000}", "", {"version":3,"sources":["/Users/chakritkanpromkad/Developer/maeriminterfood/pos_mis-master/src/views/receipt_list.vue"],"names":[],"mappings":"AACA,uBACE,wBAA0B,CAC3B,AACD,+DAGE,qBAAwB,CACzB","file":"receipt_list.vue","sourcesContent":["\ntable[data-v-6fb947cc] {\n  border-collapse: collapse;\n}\ntable[data-v-6fb947cc],\nth[data-v-6fb947cc],\ntd[data-v-6fb947cc] {\n  border: 1px solid black;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-6fb947cc","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/receipt_list.vue
// module id = 1338
// module chunks = 4